export const SET_DARK_THEME = "SET_DARK_THEME";
export const SET_BLACK_OVERLAY = "SET_BLACK_OVERLAY";
export const SET_SEARCH_RESULTS = "SET_SEARCH_RESULTS";
export const SET_PREV_PAGE = "SET_PREV_PAGE";


export const SET_LOCATION = "SET_LOCATION";

// AUTH
export const SET_TOKEN = "SET_TOKEN";
export const LOGOUT_REQUEST = "LOGOUT_REQUEST"
export const SET_PROFILE_DETAILS = "SET_PROFILE_DETAILS"
export const SET_MOBILE_NUMBER = "SET_MOBILE_NUMBER"
export const SET_EXPIRATION_TOKEN = "SET_EXPIRATION_TOKEN"

// USER ACTIVITY
export const SET_ENROLLED_SKILLS = "SET_ENROLLED_SKILLS"
export const SET_USER_ACTIVITY = "SET_USER_ACTIVITY"
export const EDIT_USER_BIO = "EDIT_USER_BIO"
export const SET_AVAILABLE_COINS = 'SET_AVAILABLE_COINS'
export const SET_AVAILABLE_COINS_COLLEGE = 'SET_AVAILABLE_COINS_COLLEGE'
export const EDIT_LAST_PLAYED = 'EDIT_LAST_PLAYED'
export const EDIT_LAST_PLAYED_COURSE = 'EDIT_LAST_PLAYED_COURSE'
export const EDIT_LAST_VISITED_SKILL = 'EDIT_LAST_VISITED_SKILL'
export const EDIT_LAST_VISITED_COURSE = 'EDIT_LAST_VISITED_COURSE'
export const EDIT_REDIRECT_TYPE = "EDIT_REDIRECT_TYPE"
export const EDIT_LAST_VISITED_MSKILL_DETAILS = "EDIT_LAST_VISITED_MSKILL_DETAILS"
export const EDIT_LAST_VISITED_CERTIFICATE = "EDIT_LAST_VISITED_CERTIFICATE"
export const EDIT_LAST_VISITED_CONTENT = "EDIT_LAST_VISITED_CONTENT"
export const EDIT_LAST_UNLOCKED_CERTIFICATE_IMAGE = "EDIT_LAST_UNLOCKED_CERTIFICATE_IMAGE"
export const EDIT_PRICING_BANNER = "EDIT_PRICING_BANNER"
export const SET_LAST_CONTENT_PLAYED = "SET_LAST_CONTENT_PLAYED"
export const SET_WELCOME_MODAL_DISMISS = 'SET_WELCOME_MODAL_DISMISS'
export const SET_LAST_MSKILL_COMPLETED = 'SET_LAST_MSKILL_COMPLETED'
export const SET_USER_ONE_DAY_TIMER = 'SET_USER_ONE_DAY_TIMER'
export const EDIT_LAST_CHALLENGE_CERTIFICATE_ID = 'EDIT_LAST_CHALLENGE_CERTIFICATE_ID'
export const SET_COMPLETE_QUIZ_TIMER = 'SET_COMPLETE_QUIZ_TIMER'
export const SET_IS_TRIAL_BLOCKED = 'SET_IS_TRIAL_BLOCKED'
export const SET_IS_WHATSAPP = 'SET_IS_WHATSAPP'
export const SET_IS_ACTIVATION = 'SET_IS_ACTIVATION'
export const SET_LAST_MSKILL_DURATION = 'SET_LAST_MSKILL_DURATION'
export const SET_USER_COIN_ACTIVITY = "SET_USER_COIN_ACTIVITY"
export const SET_CONTINUE_LEARNING = "SET_CONTINUE_LEARNING"
export const SET_UTM_DATA = "SET_UTM_DATA"

// PROFILE DETAILS
export const SHAUN_ELLIS_TEST = 'SHAUN_ELLIS_TEST'
export const NPS_TEST = 'NPS_TEST'
export const SET_IS_RECRUITER_FORM_OPEN = 'SET_IS_RECRUITER_FORM_OPEN'
export const RESET_SE_DATA = 'RESET_SE_DATA'
export const RESET_NPS_DATA = 'RESET_NPS_DATA'

// WALKTHROUGH
export const SET_WALKTHROUGH_DATA = "SET_WALKTHROUGH_DATA"

// MARKETPLACE/PREFERENCES
export const SET_COMPLETE_QUIZ_BANNER = 'SET_COMPLETE_QUIZ_BANNER'
export const SET_START_CHALLENGE_BANNER = 'SET_START_CHALLENGE_BANNER'
export const SET_COMPLETE_CHALLENGE_BANNER = 'SET_COMPLETE_CHALLENGE_BANNER'
export const SET_EXTEND_CHALLENGE_BANNER = 'SET_EXTEND_CHALLENGE_BANNER'
export const SET_JES_CALCULATED_BANNER = 'SET_JES_CALCULATED_BANNER'
export const SET_JES_IS_NOT_CALCULATED_BANNER = 'SET_JES_IS_NOT_CALCULATED_BANNER'
export const SET_DOWNLOAD_CERTIFICATE_BANNER = 'SET_DOWNLOAD_CERTIFICATE_BANNER'
export const SET_UNLOCK_CERTIFICATE_BANNER = 'SET_UNLOCK_CERTIFICATE_BANNER'
export const SET_UPGRADE_BANNER = 'SET_UPGRADE_BANNER'

// BANNER DATA
export const SET_USER_DATA_FOR_BANNER = 'SET_USER_DATA_FOR_BANNER'

// USER SUBSCRIPTION
export const SET_USER_SUBSCRIPTION = 'SET_USER_SUBSCRIPTION'
export const SET_OPEN_SUBSCRIPTION_MODAL = 'SET_OPEN_SUBSCRIPTION_MODAL'
export const SET_USER_DISCOUNT = 'SET_USER_DISCOUNT'
export const SET_USER_PRICING_CARD_ID = 'SET_USER_PRICING_CARD_ID'
export const SET_IS_ELIGIBLE_FOR_LEARNTUBE_MAX = 'SET_IS_ELIGIBLE_FOR_LEARNTUBE_MAX'
// export const SET_OPEN_SUBSCRIPTION_MODAL_COUNT = 'SET_OPEN_SUBSCRIPTION_MODAL_COUNT'
// export const SET_OPEN_SUBSCRIPTION_MODAL_COUNT = 'SET_OPEN_SUBSCRIPTION_MODAL_COUNT'

//  USER CHALLENGES
export const SET_USER_EXTENDED_CHALLENGES = "SET_USER_EXTENDED_CHALLENGES"
export const SET_USER_CHALLENGE_DATA = "SET_USER_CHALLENGE_DATA"
export const EDIT_USER_CHALLENGE_DATA = "EDIT_USER_CHALLENGE_DATA"

// EPS
export const EDIT_EPS_STEPS = "EDIT_EPS_STEPS"
export const ADD_EPS_SCORE = "ADD_EPS_SCORE"

// COURSES, SKILLS, MICROSKILLS
export const SET_ALL_COURSES = "SET_ALL_COURSES"
export const GET_ENROLLED_SKILLS = "GET_ENROLLED_SKILLS"

// Personalise Course
export const SET_ONBOARDING_DATA = "ONBOARDING_DATA"
export const GET_USER_UUID = "GET_USER_UUID"
export const GET_PERSONALISE_QUESTIONS = "GET_PERSONALISE_QUESTIONS"
export const RESET_PERSONALISE_QUESTIONS = "RESET_PERSONALISE_QUESTIONS"
export const SET_PERSONALISE_COURSE_NAME = "SET_PERSONALISE_COURSE_NAME"
export const SET_PERSONALISE_COURSE_SKILL_LEVEL = "SET_PERSONALISE_COURSE_SKILL_LEVEL"
export const SET_PERSONALISE_ANALYSIS = "SET_PERSONALISE_ANALYSIS"
export const RESET_PERSONALISE_ANALYSIS = "RESET_PERSONALISE_ANALYSIS"
export const SET_PERSONALISE_COURSE_RANDOM_NO = "SET_PERSONALISE_COURSE_RANDOM_NO"
export const SET_PERSONALISE_COURSE_USER_INTERESTS = "USER_PERSONALISE_COURSE_USER_INTERESTS"
export const SET_PERSONALISE_MCQ_ANSWER = "SET_PERSONALISE_MCQ_ANSWER"
export const RESET_PERSONALISE_MCQ_ANSWER = "RESET_PERSONALISE_MCQ_ANSWER"
export const SET_PERSONALISE_USER_RANK = "SET_PERSONALISE_USER_RANK"
export const SET_CUSTOM_SKILL_SELECTED = "SET_CUSTOM_SKILL_SELECTED"
export const GET_USER_IS_FROM_BETA_PRODUCT = "GET_USER_IS_FROM_BETA_PRODUCT"
export const SET_USER_MODAL = "SET_USER_MODAL"
export const SET_USER_PERSONALISE_COURSE = "SET USER PERSONALISE COURSE"
export const SET_USER_UNLOCKED_PERSONALISE_COURSES = "SET USER UNLOCKED PERSONALISE COURSE"


//verificatiion page

export const SET_USER_FORM_DATA = "SET_USER_FORM_DATA"
export const SET_PERSONALIZE_AUTH_DATA = "SET_PERSONALIZE_AUTH_DATA"
export const SET_USER_TYPE = "SET_USER_TYPE"
export const SET_USER_LINKEDIN_URL = "SET_USER_LINKEDIN_URL"
export const SET_LOCK_STATUS = "SET_LOCK_STATUS"
export const SET_CERTIFICATE_DATA = "SET_CERTIFICATE_DATA "
export const SET_USER_ENGAGEMENT_DATA = "SET_USER_ENGAGEMENT_DATA"
export const SET_EDIT_STATUS = "SET_EDIT_STATUS"
export const SET_USER_CV_DATA = "SET_USER_CV_DATA"
export const SET_CERTIFIED_DATA = "SET_CERTIFIED_DATA"
export const SET_REQUEST_CV_STATUS = "SET_REQUEST_CV_STATUS"
export const SET_REQUEST_INTERVIEW_STATUS = "SET_REQUEST_INTERVIEW_STATUS"
export const SET_RESET_DATA = "SET_RESET_DATA"

// Hall of Fame
export const SET_DATE_RANGE = "SET_DATE_RANGE"
export const RECOGNISED_SECTION_MODAL_DETAILS = "RECOGNISED_SECTION_MODAL_DETAILS"
export const SET_SHOW_RECOGNISED_SECTION = "SET_SHOW_RECOGNISED_SECTION"
export const SET_RECRUITER_DATA = "SET_RECRUITER_DATA"
export const RESET_RECRUITER_DATA = "RESET_RECRUITER_DATA"
export const SET_RECRUITER_FILTERS = "SET_RECRUITER_FILTERS"
export const RESET_ALL_DATA = "RESET_ALL_DATA"
export const SET_SELECTED_FILTERS = "SET_SELECTED_FILTERS"
export const RESET_SELECTED_FILTERS = "RESET_SELECTED_FILTERS"
export const SET_WISHLISTED_PROFILES = "SET_WISHLISTED_PROFILES"
export const SET_RECRUITER_ACCESS_TOKEN = "SET_RECRUITER_ACCESS_TOKEN"
export const SET_RECRUITER_UUID = "SET_RECRUITER_UUID"
export const SET_RECRUITER_AUTH_DATA = "SET_RECRUITER_AUTH_DATA"
export const SET_RECRUITER_PUBLIC_NL_SEARCH_USED = "SET_RECRUITER_PUBLIC_NL_SEARCH_USED"

// USER ROADMAP
export const SET_USER_ROADMAP_STEP = "SET_USER_ROADMAP_STEP"
export const SET_USER_EXPERIENCE = "SET_USER_EXPERIENCE"
export const SET_USER_CURRENT_EDUCATION_DEGREE = "SET_USER_CURRENT_EDUCATION_DEGREE"
export const SET_USER_EDUCATION_STREAM = "SET_USER_EDUCATION_STREAM"
export const SET_USER_IMMEDIATE_CAREER_GOAL = "SET_USER_IMMEDIATE_CAREER_GOAL"
export const SET_USER_CURRENT_JOB_ROLE = "SET_USER_CURRENT_JOB_ROLE"
export const SET_USER_ROADMAP_GOAL = "SET_USER_ROADMAP_GOAL"
export const SET_USER_ROADMAP_DATA = "SET_USER_ROADMAP_DATA"
export const SET_USER_ROADMAP_ID = "SET_USER_ROADMAP_ID"
export const SET_USER_ROADMAP_COURSES = "SET_USER_ROADMAP_COURSES"
export const SET_USER_ROADMAP_PLACEMENT_SERVICES = "SET_USER_ROADMAP_PLACEMENT_SERVICES"
export const SET_USER_SWITCH_STATE = "SET_USER_SWITCH_STATE"
export const SET_USER_IS_GOAL = "SET_USER_IS_GOAL"


// ONBOARDING
export const SET_ONBOARDING_STEP = "SET_ONBOARDING_STEP"
export const SET_ONBOARDING_TYPE = "SET_ONBOARDING_TYPE"
export const SET_ONBOARDING_PURPOSE = "SET_ONBOARDING_PURPOSE"
export const SET_ONBOARDING_EXPERIENCE = "SET_ONBOARDING_EXPERIENCE"
export const SET_ONBOARDING_GOAL = "SET_ONBOARDING_GOAL"
export const SET_ONBOARDING_WAY_TO_REACH = "SET_ONBOARDING_WAY_TO_REACH"
export const SET_ONBOARDING_SECOND_BRANCH = "SET_ONBOARDING_SECOND_BRANCH"
export const SET_ONBOARDING_SELECTED_SKILL = "SET_ONBOARDING_SELECTED_SKILL"
export const SET_ONBOARDING_RELATED_SUBJECTS = "SET_ONBOARDING_RELATED_SUBJECTS"
export const SET_ONBOARDING_RELATED_PERSONALISED_SKILLS = "SET_ONBOARDING_RELATED_PERSONALISED_SKILLS"
export const SET_ONBOARDING_PERSONALISED_SKILLS_LOADING = "SET_ONBOARDING_PERSONALISED_SKILLS_LOADING"
export const SET_ONBOARDING_IS_LOADING = "SET_ONBOARDING_IS_LOADING"
export const SET_ONBOARDING_SUCCESS_UUID = "SET_ONBOARDING_SUCCESS_UUID"
export const SET_ONBOARDING_X_PRODUCT = "SET_ONBOARDING_X_PRODUCT"
export const SET_ONBOARDING_MAX_PRODUCT = "SET_ONBOARDING_MAX_PRODUCT"
export const SET_USER_ACCESS = "SET_USER_ACCESS"
export const SET_ONBOARDING_IS_PREMIUM = "SET_ONBOARDING_IS_PREMIUM"
export const SET_COURSE_UNLOCK_POLLING = "SET_COURSE_UNLOCK_POLLING"
export const SET_COURSE_UNLOCK_STATUS = "SET_COURSE_UNLOCK_STATUS"


// SEO
export const SET_IS_SEO = "SET_IS_SEO"
export const SET_SEO_TYPE = "SET_SEO_TYPE"
export const SET_SEO_COURSE_SLUG = "SET_SEO_COURSE_SLUG"


//DELETE
export const SET_IS_DELETE_ACCOUNT = "SET_IS_DELETE_ACCOUNT"

// ROADMAP V2
export const SET_ROADMAP_V2_STATE = "SET_ROADMAP_V2_STATE"
export const SET_ROADMAP_V2_DATA = "SET_ROADMAP_V2_DATA"
export const SET_ROADMAP_V2_STATUS = "SET_ROADMAP_V2_STATUS"
export const SET_ROADMAP_V2_GOALS = "SET_ROADMAP_V2_GOALS"
export const SET_ROADMAP_V2_CERTIFICATE = "SET_ROADMAP_V2_CERTIFICATE"
export const SET_ROADMAP_V2_NEXT_GOALS = "SET_ROADMAP_V2_NEXT_GOALS"
export const SET_ROADMAP_V2_LOADING = "SET_ROADMAP_V2_LOADING"
export const SET_ROADMAP_V2_ERROR = "SET_ROADMAP_V2_ERROR"
export const SET_ROADMAP_V2_UNLOCKED_COURSES = "SET_ROADMAP_V2_UNLOCKED_COURSES"
export const SET_ROADMAP_V2_CERTIFIED_ENROLLMENTS = "SET_ROADMAP_V2_CERTIFIED_ENROLLMENTS"
export const RESET_ROADMAP_V2 = "RESET_ROADMAP_V2"